<template>
  <div class="card">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-3 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6 text-psychology-warning">
          <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path>
          <path d="M9 18h6"></path>
          <path d="M10 22h4"></path>
        </svg>
        答题建议
      </div>

      <div class="grid gap-4">
        <div class="flex items-start gap-3 p-3 border border-gray-200 rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success mt-0.5 flex-shrink-0">
            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
          </svg>
          <div>
            <h4 class="font-medium text-gray-900 mb-1">诚实作答</h4>
            <p class="text-sm text-gray-600">根据真实感受作答，没有对错之分，不要美化或贬低</p>
          </div>
        </div>

        <div class="flex items-start gap-3 p-3 border border-gray-200 rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary mt-0.5 flex-shrink-0">
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="6"></circle>
            <circle cx="12" cy="12" r="2"></circle>
          </svg>
          <div>
            <h4 class="font-medium text-gray-900 mb-1">第一直觉</h4>
            <p class="text-sm text-gray-600">相信第一直觉，不要过度思考，快速选择最符合的选项</p>
          </div>
        </div>

        <div class="flex items-start gap-3 p-3 border border-gray-200 rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-secondary mt-0.5 flex-shrink-0">
            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
            <path d="m9 11 3 3L22 4"></path>
          </svg>
          <div>
            <h4 class="font-medium text-gray-900 mb-1">完整作答</h4>
            <p class="text-sm text-gray-600">尽量完成所有问题，跳过太多会影响结果的准确性</p>
          </div>
        </div>

        <div class="flex items-start gap-3 p-3 border border-gray-200 rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-accent mt-0.5 flex-shrink-0">
            <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
          </svg>
          <div>
            <h4 class="font-medium text-gray-900 mb-1">隐私环境</h4>
            <p class="text-sm text-gray-600">在私密、不被打扰的环境中完成，确保可以专注思考</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnswerTips'
}
</script>

